

export const BaseUrl={
    baseURL: "https://nextphoto.pythonanywhere.com/",
    imageURL: "https://nextphoto.pythonanywhere.com/",

}